import {
  asset1,
  asset2,
  asset3,
  asset4,
  asset5,
  asset6,
  asset7,
  asset8,
  nikeLogo,
  nikeLogoShadow,
  nikeLogoStitch,
  nikeLogoOutline,
  blackSuede,
  cinderOrangeSuede,
  alabasterSuede,
  placeholder,
} from './assets'
import { webs } from 'data/baseball/shado-elite/top'

const assets = [
  { src: asset1, x: 0, y: 0, itemId: 101 },
  { src: asset8, x: 65, y: 59, itemId: 102 },
  { src: asset4, x: 24.6981, y: -2.3358, itemId: 110, majorLayer: true },
  { src: asset6, x: 195.4143, y: 740.55, itemId: 105, majorLayer: true },
  { src: asset5, x: 189.4326, y: 740.6553, itemId: 109, majorLayer: true },
  { src: asset2, x: -3.3216, y: 6.1605, itemId: 108 },
  { src: asset3, x: 10.9845, y: 114.5583, itemId: 101 },
  { src: asset7, x: 68, y: 147.0538, itemId: 103 },
  { src: nikeLogoOutline, x: 399.3222, y: 506.7961, itemId: 107 },
  {
    src: nikeLogoStitch,
    x: 403.9926,
    y: 511.1977,
    itemId: 107,
    darken: 40,
  },
  { src: nikeLogo, x: 403.9926, y: 511.1977, itemId: 106 },
  {
    src: nikeLogoShadow,
    x: 375.1644,
    y: 513.7723,
    globalComposition: 'multiply',
  },
  { src: placeholder, x: 0, y: 0, itemId: 116, majorLayer: true },
  { itemId: 113, x: 560, y: 500, fontSize: 28, angle: -72 },
  { itemId: 114, x: 50, y: 290, fontSize: 24, angle: 92 },
]

const data = {
  assets: assets,
  ...webs,
  'black-suede': [{ src: blackSuede, x: 2, y: 2, zindex: 1 }],
  'cinder-orange-suede': [{ src: cinderOrangeSuede, x: 2, y: 2, zindex: 1 }],
  'alabaster-suede': [{ src: alabasterSuede, x: 2, y: 2, zindex: 1 }],
}

export default data
